export default __webpack_public_path__ + "static/media/Whale.eebc54cc.png";